export default __webpack_public_path__ + "static/winter29-ff8398afa988c36390ea70c457bdc2dd.webp";